import { render, staticRenderFns } from "./LimitClubAddOnSelectItem.vue?vue&type=template&id=63b5e8a4&scoped=true"
import script from "./LimitClubAddOnSelectItem.vue?vue&type=script&lang=ts"
export * from "./LimitClubAddOnSelectItem.vue?vue&type=script&lang=ts"
import style0 from "./LimitClubAddOnSelectItem.vue?vue&type=style&index=0&id=63b5e8a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b5e8a4",
  null
  
)

export default component.exports